import { Reveal } from "./Reveal";


export const gallery = [
  { src: "/img/g9.webp", alt: "Zona con sofás marroquíes y cojines dorados tradicionales en Yasmina Puigcerdà", tall: true },
  { src: "/img/g6.webp", alt: "Comedor principal de Yasmina con mesas de madera y vistas a la plaza" },
  { src: "/img/g2.webp", alt: "Comedor y barra de Yasmina con luz natural" },
  { src: "/img/g11-v2.webp", alt: "Detalle del comedor de Yasmina, reloj clásico y mesas de madera" },
];

export const GallerySection = ({ t }) => (
  <section className="gallery" data-testid="gallery-section" style={{ background: "var(--bg)" }}>
    <div className="container">
      <Reveal><div className="label">{t("gallery_kicker")}</div></Reveal>
      <Reveal delay={1}><h2 style={{ marginTop: 14, maxWidth: 820 }}>{t("gallery_title")}</h2></Reveal>
      <Reveal delay={2}><p style={{ marginTop: 20, maxWidth: 560 }}>{t("gallery_lead")}</p></Reveal>
      <div className="gallery-grid">
        {gallery.map((g, i) => (
          <Reveal key={i} delay={Math.min(4, (i % 4) + 1)}>
            <figure className={`gal-item ${g.tall ? "tall" : ""}`} data-testid={`gallery-item-${i}`}>
              <img src={g.src} alt={g.alt} loading="lazy" />
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
